import { StateToken } from '@ngxs/store';

import { AddGroupModelsProgress } from '../../models';

export interface StudyStateModel {
  modelsAdditionProgress: AddGroupModelsProgress[];
}

export const PROJECT_STUDY_STATE_TOKEN = new StateToken<StudyStateModel>('study');
